export default "__VITE_ASSET__DNzlehKT__"